'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'star-half';
var width = 576;
var height = 512;
var aliases = [61731];
var unicode = 'f089';
var svgPathData = ['M84.1 216.8L207 195.5l13.5-2.3 7.6-11.3 52-77.1 0 304.4L161.5 460.1l18.3-127 2.2-15.6-11-11.3L84.1 216.8z', 'M148.1 328.5L127 474.9 121.7 512l34.5-14.8 155.9-67 0-372.9 0-57.3-32 47.5L201.6 164 57.1 189l-38.2 6.6 27 27.8L148.1 328.5zm-64-111.7L207 195.5l13.5-2.3 7.6-11.3 52-77.1 0 304.4L161.5 460.1l18.3-127 2.2-15.6-11-11.3L84.1 216.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarHalf = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;